import {useEffect, useState} from "react";
import {axiosInstance} from "../lib/axios";

export default function TxnStatsBar({from, to}) {
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    axiosInstance
      .get("/admins/transactions/stats", {params})
      .then((r) => setData(r.data?.data))
      .catch(() => setData(null));
  }, [from, to]);

  const Card = ({title, value, tone}) => {
    const tones = {
      success: "bg-green-50 border-green-200",
      pending: "bg-amber-50 border-amber-200",
      failed: "bg-rose-50 border-rose-200",
    }[tone];
    return (
      <div className={`flex-1 rounded-xl border ${tones} p-4`}>
        <div className="text-sm font-medium mb-2">{title}</div>
        <div className="text-3xl font-semibold">{value ?? "—"}</div>
      </div>
    );
  };

  return (
    <div className="rounded-2xl border border-slate-200 p-3 bg-slate-50">
      <div className="flex gap-3">
        <Card
          title="Successful Payment"
          value={data?.successful}
          tone="success"
        />
        <Card title="Pending Payment" value={data?.pending} tone="pending" />
        <Card title="Failed" value={data?.failed} tone="failed" />
      </div>
    </div>
  );
}
